<template lang="pug" src="./block-cta-modal.pug"></template>

<script>
// import Form from 'components/form/form-contact/form-contact'
export default {
  props: ['props'],
  methods: {
    activate () {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false)
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// block-cta-modal.vue?74499b56